import { z } from '@harvestiq/zod';
import { dbFaqInsertSchema } from './db-faq';
import { faqSchema } from './faq';

export const createFaqRequestBodySchema = dbFaqInsertSchema.pick({
  question: true,
  answer: true,
});

export type CreateFaqRequestBody = z.infer<typeof createFaqRequestBodySchema>;

export const createFaqResponseSchema = z.object({
  success: z.boolean(),
  faq: faqSchema,
});

export type CreateFaqResponse = z.infer<typeof createFaqResponseSchema>;
